"use strict";
/**
 * Application Use Cases.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenerateIllustrationUseCase = exports.CreatePolicyUseCase = void 0;
const domain_1 = require("../domain");
class CreatePolicyUseCase {
    policyRepo;
    constructor(policyRepo) {
        this.policyRepo = policyRepo;
    }
    async execute(command) {
        const customer = new domain_1.Customer(command.customerId, command.customerName, new domain_1.Age(command.customerAge), command.customerGender);
        const policy = new domain_1.PolicyAggregate(command.policyId, customer, command.productCode, new domain_1.ProductPlan(command.planName), new domain_1.Money(command.basePremiumAmount), new domain_1.SumAssured(command.sumAssuredAmount), new domain_1.TermInYears(command.termYears));
        if (command.riders && command.riders.length > 0) {
            for (const riderDto of command.riders) {
                const rider = new domain_1.RiderConfig(riderDto.riderId, riderDto.riderName, new domain_1.Money(riderDto.sumAssuredAmount), new domain_1.Money(riderDto.annualPremiumAmount));
                policy.attachRider(rider);
            }
        }
        await this.policyRepo.save(policy);
        return policy;
    }
}
exports.CreatePolicyUseCase = CreatePolicyUseCase;
class GenerateIllustrationUseCase {
    policyRepo;
    constructor(policyRepo) {
        this.policyRepo = policyRepo;
    }
    async execute(policyId) {
        const policy = await this.policyRepo.getById(policyId);
        if (!policy) {
            throw new Error(`Policy with ID ${policyId} not found`);
        }
        return domain_1.IllustrationDomainService.generateCashFlowTable(policy);
    }
}
exports.GenerateIllustrationUseCase = GenerateIllustrationUseCase;
